import React from 'react';
import Paginations from '../../common/paginations';
import constant from '../../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ProjectWiseDocumentCount = ({ data, setCurrentPage, limit }) => {
  const { projects, total, page } = data;

  return (<>
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table align-middle table-nowrap table-hover">
                <thead className="table-light">
                  <tr>
                    <th scope="col" style={{ width: 70 }}>#</th>
                    <th scope="col">Project</th>
                    <th scope="col">Total Document</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {projects?.length > 0 ? (
                    projects.map((item, index) => (
                      <tr key={item.PROJECT_ID || index}>
                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                          {((page - 1) * limit) + index + 1}
                        </td>
                        <td>
                          <h5 className="font-size-14 mb-1">
                            <Link
                              to={{
                                pathname: constant.Authedcomponent.shipGuarantyClaims.url,
                                state: {
                                  data: btoa(JSON.stringify(item)),
                                },
                              }}
                              className="text-dark"
                            >
                              {item.PROJECT_CODE} - {item.PROJECT_NAME}
                            </Link>

                          </h5>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: constant.Authedcomponent.shipGuarantyClaims.url,
                              state: {
                                data: btoa(JSON.stringify(item)),
                              },
                            }}
                            className="text-dark"
                          >
                            <span style={{ color: "#676767" }}>
                              {item.CLAIM_COUNT ?? 0}
                            </span>
                          </Link>

                        </td>
                        <td>
                          <ul className="list-inline font-size-14 contact-links mb-0">
                            <li className="list-inline-item px-2">
                              <Link
                                to={{
                                  pathname: constant.Authedcomponent.shipGuarantyClaims.url,
                                  state: {
                                    data: btoa(JSON.stringify(item)),
                                  },
                                }}
                                title="List"
                                style={{ color: "#319bfc" }}
                              >
                                <i className="fa fa-list" aria-hidden="true" /> List
                              </Link>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Paginations
      limit={limit}
      totalCount={total}
      range={5}
      currentPage={page}
      onPageChange={setCurrentPage}
    />
  </>
  );
};

export default ProjectWiseDocumentCount;
